module.exports = __webpack_public_path__ + "img/2025-08-16b_5.7f9613ea.jpg";